import React from 'react';
// Constants
import { CompanyName, KeywordsPages, MainTitle } from '../../utils/Constants';
// Data
import {
  linksPageAdditionalMeta,
  linksPageStructuredData,
} from '../../utils/data/MetaData';
import { externalLinksArray } from '../../utils/data/LinksData';
// Images
import linksHeaderMain from '../../assets/images/headers/my-extra-links-header-barbie-style.png';
import TopMainMobileImage from '../../assets/images/temp/1741544558056.png';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import GeneralHeader from '../../components/general/GeneralHeader';

function LinksPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Links'
        desc='Explore all the essential links to connect with Mistress Sammi Smith, a fierce and seductive trans dominatrix. Find exclusive content, booking details, and more.'
        keywords={KeywordsPages}
        additionalMeta={linksPageAdditionalMeta}
        structuredData={linksPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1 w-full h-full font-poppins'>
        <div className='grid h-fit'>
          {/* Navigation */}
          <Navbar />
          <GeneralHeader
            headerMainImage={linksHeaderMain}
            headerMobileImage={linksHeaderMain}
            mainTitle={`${MainTitle}`}
            subtitle={`My Domination Lifestyle`}
          />
        </div>

        {/* Main page content */}
        <main role='main' className='grid w-full h-full overflow-hidden pb-12'>
          <section className='py-8 relative'>
            <img
              src={TopMainMobileImage}
              alt={`${CompanyName} and her sexy content`}
              className='max-h-[80vh] lg:max-h-[60vh] mx-auto'
            />
            <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'>
              <p className='text-5xl lg:text-7xl font-titleFont whitespace-nowrap pink_glow'>
                See more like this!
              </p>
            </div>
          </section>

          {/* Links array */}
          <section className='grid gap-4 md:gap-6 justify-center'>
            <section>
              <div className='grid text-center'>
                <h4 className='text-2xl sm:text-3xl md:text-4xl font-titleFont'>
                  Follow Me & Spoil Me On
                </h4>
              </div>
            </section>
            <div className='grid gap-6 justify-center bg-colour5 py-8 px-6 md:px-12 shadow-cardShadow'>
              {externalLinksArray.map((link, index) => (
                <a
                  key={index}
                  href={link.url}
                  title={link.title}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='hover:scale-105 transition-transform duration-300'
                >
                  <img
                    src={link.image}
                    alt={link.alt}
                    className='w-48 h-auto rounded shadow-md'
                  />
                </a>
              ))}
            </div>
          </section>
        </main>
      </div>
    </>
  );
}

export default LinksPage;
